import { initBCTabs, initBCAbbr, initBCLoadingIcon, initBCTooltip } from "js/basic-components/";
import { initBCWJInternalNav, initBCUsageWidget, initBCDSLForm } from "./js/components/";

initBCTabs();
initBCUsageWidget();
initBCWJInternalNav();
initBCLoadingIcon();
initBCTooltip();
initBCAbbr();
initBCDSLForm();
